import script from "./IndyaInFacts.vue?vue&type=script&setup=true&lang=js"
export * from "./IndyaInFacts.vue?vue&type=script&setup=true&lang=js"

import "./IndyaInFacts.vue?vue&type=style&index=0&id=50562c28&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50562c28"]])

export default __exports__